import { render, staticRenderFns } from "./DocumentViewer (deprecated).vue?vue&type=template&id=74dfd08e&"
import script from "./DocumentViewer (deprecated).vue?vue&type=script&lang=js&"
export * from "./DocumentViewer (deprecated).vue?vue&type=script&lang=js&"
import style0 from "./DocumentViewer (deprecated).vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports